import React from 'react';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SortIcon from '@mui/icons-material/ArrowUpward';

import { SortCriteria, SortDirection } from '@apps/shared/src/providerSearch/types/providerSearch';
import { setSortCriteria, toggleSortDirection } from '@apps/shared/src/providerSearch/actions';
import { RootState } from '../../store';
import { IncompleteTheme } from '../../shared/types/theme';

const AscendingIcon = styled(SortIcon)({
  transform: 'scaleY(-1)',
});

const SortContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

const StyledSelect = styled(Select)({
  width: '100%',
  '& .MuiSelect-select': {
    background: '#ffffff',
    border: '1px solid #E5EBF5',
    padding: '12px 16px',
  },
});

const Header = styled(Typography)(({ theme }) => ({
  ...(theme as IncompleteTheme).sidebar.headerText,
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...(theme as IncompleteTheme).selectMenuItem,
  display: 'block',
  padding: '12px 16px',
  minHeight: '48px',
}));

const mapStateToProps = ({ providerSearch }: RootState): StateProps => ({
  sortCriteria: providerSearch.sortCriteria,
  sortDirection: providerSearch.sortDirection,
  isLoading: providerSearch.isLoadingProviderList,
});
type StateProps = {
  sortCriteria: SortCriteria;
  sortDirection: SortDirection;
  isLoading: boolean;
};

const mapDispatchToProps = {
  setSortCriteria,
  toggleSortDirection,
};

type Props = StateProps & typeof mapDispatchToProps;

export function SortControl({
  sortCriteria,
  sortDirection,
  setSortCriteria,
  toggleSortDirection,
  isLoading,
}: Props): JSX.Element {
  const handleChange: SelectProps['onChange'] = e => {
    setSortCriteria(e.target.value as SortCriteria);
  };

  const handleDirectionClick: VoidFunction = () => {
    toggleSortDirection();
  };

  return (
    <div>
      <Header>Sort By</Header>
      <SortContainer>
        <FormControl fullWidth>
          <StyledSelect
            value={sortCriteria}
            id="sort-search"
            onChange={handleChange}
            labelId="sort-criteria"
            disableUnderline
            disabled={isLoading}
          >
            <StyledMenuItem value="distance">Distance</StyledMenuItem>
            <StyledMenuItem value="accessibility">Accessibility</StyledMenuItem>
            <StyledMenuItem value="name">Provider Name</StyledMenuItem>
          </StyledSelect>
        </FormControl>
        <IconButton
          color="primary"
          edge="end"
          id={`sort-${sortDirection}`}
          value={sortDirection}
          onClick={handleDirectionClick}
          aria-label="toggle sort direction"
          disabled={isLoading}
          size="large"
        >
          {sortDirection === 'asc' ? <AscendingIcon /> : <SortIcon />}
        </IconButton>
      </SortContainer>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SortControl);
